module.exports = __webpack_public_path__ + "static/media/laowumianshi2.57ba9240.png";